import type { User } from 'firebase/auth';
import { atom } from 'jotai';

type AuthState = {
    user: User | null;
    loading: boolean;
};

export const authState = atom<AuthState>({
    user: null,
    loading: true,
});

export const currentUserState = atom((get) => get(authState).user);
export const currentUserIdState = atom((get) => get(currentUserState)?.uid);
